import type { PropsWithChildren } from 'react';

const MainWrapper = ({ children }: PropsWithChildren) => (
  <div className='wrapper'>{children}</div>
);

export default MainWrapper;
